export class SharePointPracticeModel {
  public sharepointPracticeId: any = 0;
  public accountingFirmId: any = 1;
  public preferredName: string;
  public isDeleted: any;
  public isSharePointConnected: any;
  public spConnectoinType: any
}
export class AzureSettingsModel {
  public dmsProviderType: boolean = false;
  public resourcesDefault: any;
  public redirectUri: any;
  public instance: any;
  public tenantId: any;
  public azureAuth: any;
  public clientId: any;
  public azureAuthLogout: any;
  public reloadUri: any;

}

export enum DocDefaultPreferenceEnum {
  'Preview' = 1,
  'Browser' = 2,
  'DesktopApp' = 3
}

export enum DmsFilters {
  Client = 'Client',
  ClientGroups = 'Client groups',
  Document = 'Document',
  Folder = 'Folder'
}

export enum FILTER_SP_Type {
  Client = 'Client',
  Item = 'Item',
  Common = 'Common',
  KCScreen = 'KCClientGroup',
}

export enum DmsScreenTypeFilters {
  Client = 'client',
  clientGroups = 'clientGroups',
  clientSite = 'clientSite',
  nonClientSite = 'nonClientSite'
}

export enum DmsActionTypes {
  Client = 'Client',
  globalUpload = 'globalUpload',
  bulkUpdate = 'bulkUpdate',
  createAction = 'createAction',
}

export const DMS_ACTION_MENU_NAMES = {
  openInBrowser: "Open in browser",
  openInDesktop: "Open in desktop app",
  preview: "Preview",
  previewAttachments: "Preview attachments",
  editProperties: "Edit properties",
  copyTo: "Copy to",
  moveTo: "Move to",
  activity: "Activity",
  versionHistory: "Version history",
  download: "Download",
  delete: "Delete",
  openFileLocation: "Open file location",
  sync_to_OneDrive: "Sync to OneDrive",
  remove_from_OneDrive: "Remove from OneDrive",
  requestFiles: "Request files",
  createTask: "Create task",
  shareLink: "Share link",
}

export const DMS_DOCUMENT_FILTERS = {
  Client: 'Client',
  ClientGroups: 'Client groups',
  Document: 'Document',
  Folder: 'Folder',
} as const;

export const DMS_SCREEN_TYPE_FILTER_VALUES = {
  clientSite: {
    filterValues: [
      { id: 1, name: DmsFilters.Client, icon: '../../../assets/img/client_icon.svg', type: FILTER_SP_Type.Client, KCType: FILTER_SP_Type.KCScreen },
      { id: 2, name: DmsFilters.ClientGroups, icon: '../../../assets/img/client_group_icon.svg', type: FILTER_SP_Type.Client },
      { id: 3, name: DmsFilters.Document, icon: '../../../assets/img/document_icon.svg', type: FILTER_SP_Type.Common, KCType: FILTER_SP_Type.KCScreen },
    ]
  },
  client: {
    filterValues: [
      { id: 3, name: DmsFilters.Document, icon: '../../../assets/img/document_icon.svg', type: FILTER_SP_Type.Common, KCType: FILTER_SP_Type.KCScreen },
      { id: 4, name: DmsFilters.Folder, icon: '../../../assets/img/folder_icon.svg', type: FILTER_SP_Type.Item, KCType: FILTER_SP_Type.KCScreen },
    ]
  },
  clientGroups: {
    filterValues: [
      { id: 1, name: DmsFilters.Client, icon: '../../../assets/img/client_icon.svg', type: FILTER_SP_Type.Client, KCType: FILTER_SP_Type.KCScreen },
      { id: 3, name: DmsFilters.Document, icon: '../../../assets/img/document_icon.svg', type: FILTER_SP_Type.Common, KCType: FILTER_SP_Type.KCScreen },
      { id: 4, name: DmsFilters.Folder, icon: '../../../assets/img/folder_icon.svg', type: FILTER_SP_Type.Item, KCType: FILTER_SP_Type.KCScreen },
    ]
  },
  nonClientSite: null,
} as const;


export const APP_CONSTANTS = {
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
};


export interface DmsBreadcrumb {
  folderId: string;
  folderName: string;
  clientName: string;
  parentFolderId?: string;
  siteId?: string;
  rootFolderId?: string;
  isActive?: boolean;
  documentsData?: any;
  isClientGroup?: boolean;
  isRootFolder?: boolean;
  folderData?: any;
}

export interface BreadCrumbInfo {
  breadcrumbPath: string;
  rootFolderName: string;
  clientName: string;
  clientData?: any;
  rootFolderID?: string;
}

export interface AdvancedFilterColumn {
  id: string;
  name: string;
  source: 'CLIENT' | 'GROUP' | 'METADATA';
  dataType: 'TEXT' | 'CHOICE' | 'YESNO' | 'DATE';
  values?: any[];
}

export interface ColumnModel {
  fieldLabel: string;
  headerText: string;
  textAlign?: string;
  width?: number;
  visible: boolean;
}

export const CLIENT_STATUS = {
  Active: 'Active',
  Archive: 'Archive',
  Lost: 'Lost',
  Prospect: 'Prospect'
} as const;

export const CLIENT_STATUS_VALUES = Object.values(CLIENT_STATUS);

export interface FilterData<TValue = any> {
  column: string | null;
  condition: string | null;
  value: TValue[];
  availableConditions: string[];
  availableValues: TValue[];
  fieldType?: string;
}

export const ADVANCE_SEARCH_FILTER_DROPDOWN_VALUES = {
  fileTypeValues: [
    { id: 'pdf', name: 'PDF' },
    { id: ['docx', 'doc'], name: 'Word Document' },
    { id: ['xlsx', 'xls'], name: 'Excel Spreadsheet' },
    { id: 'txt', name: 'Text File' },
    { id: ['jpeg', 'jpg', 'png'], name: 'Image File' },
    { id: 'pptx', name: 'PowerPoint Presentation' },
    { id: 'vsdx', name: 'Visio Diagram' },
    { id: 'mp3', name: 'Audio File' },
    { id: ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'ts'], name: 'Video File' },
    { id: ['msg', 'eml'], name: 'Email Message' }
  ],
  yesOrNoValues: [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' }
  ]
}

export const OPERATOR_CONFIG = {
  // System filters
  ClientStatus: ['EQUAL', 'NOT_EQUAL', 'CONTAIN', 'NOT_CONTAIN'],
  ClientId: ['EQUAL', 'NOT_EQUAL', 'CONTAIN', 'NOT_CONTAIN'],
  ClientGroupName: ['EQUAL', 'NOT_EQUAL', 'CONTAIN', 'NOT_CONTAIN'],

  Modified: ['BETWEEN'],

  TaskAttached: ['EQUAL'],

  FileEXT: ['EQUAL', 'CONTAIN'],

  // Metadata fallback rules
  TEXT: ['EQUAL', 'CONTAIN', 'IS_EMPTY', 'IS_NOT_EMPTY'],
  DATE: ['EQUAL', 'IS_EMPTY', 'IS_NOT_EMPTY'],
  YESNO: ['EQUAL', 'IS_EMPTY', 'IS_NOT_EMPTY'],
  CHOICE: ['EQUAL', 'NOT_EQUAL', 'CONTAIN', 'NOT_CONTAIN', 'IS_EMPTY', 'IS_NOT_EMPTY']
};
export interface DATERANGES {
  weekStart: Date;
  weekEnd: Date;
  monthStart: Date;
  monthEnd: Date;
  lastweekStart: Date;
  lastweekEnd: Date;
  lastStart: Date;
  lastEnd: Date;
  last3monthStart: Date;
  last3monthEnd: Date;
  last6monthStart: Date;
  last6monthEnd: Date;
  yearStart: Date;
  yearEnd: Date;
}

export interface TemplateModel {
  name: string;
  nameWithoutExtension: string;
  uploadedBy: string;
  fullBlobPath: string;
  webUrl: string;
  blobModifiedUtc: Date;
  TemplateName: string;
  UploadedOn: Date;
  UploadedBy: string;
  size: number;
}

export const DmsStandardDates = {
  maxDate: new Date(2099, 11, 31),
  minDate: new Date(1900, 0, 1)
}

export interface DeleteFolderRequest {
  folderId: string;
  driveId: string;
  driveItemId: string;
}

export class ExplorerItem {
  id: string;
  parentId: string | null;
  name: string;
  type: 'Folder' | 'File';
  createdBy: string;
  createdOn: string;
  fileImageUrl?: string;
  fullBlobPath?: string;
  parentPath?: string;
  leaseStatus?: string;
  isLocked?: boolean;
  webUrl?: string;
  deleteStatus?: string;
}

export interface DmsTemplateBreadcrumb {
  id: string;
  name: string;
  path: string;
}